import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import pdficon from "./pdf.png";

function Edit_Repair_Form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE_URL1 = process.env.REACT_APP_API_BASE_URL1;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [error, setError] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [RptMgrName, setRptMgrName] = useState('');
    const [departments, setDepartments] = useState([]);
    const [AdtMgrName, setAdtMgrName] = useState('');
    const [ActMgrName, setActMgrName] = useState('');
    const [fuelImages, setImgRows] = useState('');
    const [fuelContentsImages, setFuelContentsImages] = useState('');
    const [Grade, setGrade] = useState('');
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const { id } = useParams();
    const Loader = () => (
        <div className="loader-container1">
            <div className="spinner1"></div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        mode_of_travel: '',
        to_city: '',
        guesthouse: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        total_fuel_amt: '',
        total_fuel_qty: '',
        img: []  // To store the image files
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [transportRows, setTransportRows] = useState([{
        id: 1,
        dated: '',
        repair_date: '',         // Repair Date
        repair_time: '',     // Repair Time
        driver_bmid: '',           // Driver BMID
        purpose: '',         // Purpose
        repair_amount: '',     // Amount
        remarks: '',         // Remarks
        meter_reading: '',   // Meter Reading
        meter_reading_image: [] // Attachment
    }]);


    useAuth();  // Custom hook for authentication

    const handleBackClick = () => {
        navigate("/reporting_manager_repair_forms");
    };

    const handleAddTransportRow = () => {
        setTransportRows([
            ...transportRows,
            {
                id: transportRows.length + 1,
                dated: '', // Repair Date
                repair_date: '',
                repair_time: '', // Repair Time
                driver_bmid: '', // Driver Bmid
                purpose: '', // Purpose
                repair_amount: '', // Amount
                remarks: '', // Remarks
                meter_reading: '', // Meter Reading
                meter_reading_image: [], // Attachment
            }
        ]);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };




    // fetch vehicle makes
    const fetchVehicleMakes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleMakes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleMakes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        const loadAllData = async () => {
            try {
                await Promise.all([

                    fetchVehicleMakes()
                ]);
            } catch (error) {
                console.error('Error loading data:', error);
            } finally {
                //  setLoading(false);
            }
        };

        loadAllData();
    }, [navigate]);



    const handleTransportChange = async (index, e) => {
        const { name, value, type, files, id } = e.target;
        const newTransportRows = [...transportRows];
        newTransportRows[index] = { ...newTransportRows[index], [name]: value };


        const MAX_SIZE = 1 * 1024 * 1024; // 1MB in bytes

        // If the input type is 'file' and there are selected files
        if (type === 'file' && files.length > 0) {
            const file = files[0]; // Get the first selected file

            if (file.type === 'application/pdf') {
                // Directly store PDF file without resizing
                newTransportRows[index] = { ...newTransportRows[index], [name]: file };
            } else {
                try {
                    const resizedFile = await resizeImage(file, 1024, 1024, 1); // Resize only images
                    newTransportRows[index] = { ...newTransportRows[index], [name]: resizedFile };
                } catch (error) {
                    toast.error(error.message);
                    return;
                }
            }
        } else {
            newTransportRows[index] = { ...newTransportRows[index], [name]: value };
        }





        // Update the transport rows state
        setTransportRows(newTransportRows);
    };





    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const MAX_SIZE = 1 * 1024 * 1024;
        const MAX_WIDTH = 800;
        const MAX_HEIGHT = 800;

        const validFiles = [];

        files.forEach(file => {
            if (file.size > MAX_SIZE) {
                resizeImage(file, MAX_WIDTH, MAX_HEIGHT, (resizedFile) => {
                    validFiles.push(resizedFile);
                    setFormData(prevData => ({
                        ...prevData,
                        img: validFiles
                    }));
                });
            } else {
                validFiles.push(file);
            }
        });

        setFormData(prevData => ({
            ...prevData,
            img: validFiles
        }));
    };

    const resizeImage = (file, maxWidth, maxHeight, callback) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                let width = img.width;
                let height = img.height;

                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    const resizedFile = new File([blob], file.name, {
                        type: file.type,
                        lastModified: Date.now(),
                    });
                    callback(resizedFile);
                }, file.type);
            };
        };
    };





    const handleRemoveTransportRow = (index) => {
        if (transportRows.length > 1) {
            setTransportRows(transportRows.filter((_, i) => i !== index));
        }
    };

    //fetch fuel form data
    const fetchRepairFormData = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getRepairFormById/${id}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result.status && result.data) {
                const fuelForm = result.data;
                const fuelRows = result.fuelFormContents;
                const fuelImages = result.fuelFormImages;
                const fuelContentsImages = result.fuelFormContentsImages;
                setRptMgrName(result.reportManagerName.comp_name || '');
                setAdtMgrName(result.auditManagerName.comp_name || '');
                setActMgrName(result.accountsManagerName.comp_name || '');

                setFormData({
                    id: fuelForm.id || '',
                    emp_code: fuelForm.emp_code || '',
                    comp_name: fuelForm.comp_name || '',
                    mobile: fuelForm.mobile || '',
                    dated: fuelForm.dated || '',
                    bank_acnum: fuelForm.bank_acnum || '',
                    bank_name: fuelForm.bank_name || '',
                    ifsc_code: fuelForm.ifsc_code || '',
                    location_name: fuelForm.location_name || '',
                    grade: fuelForm.grade || '',
                    dept_name: fuelForm.dept_name || '',
                    designation_name: fuelForm.designation_name || '',
                    report_mngr: fuelForm.rpt_mgr || '',
                    isSubmited: fuelForm.isSubmited || 'NO',
                    total_fuel_qty: fuelForm.total_fuel_qty || '0',
                    total_fuel_amt: fuelForm.total_fuel_amt || '0',
                    audit_status: fuelForm.audit_status || '',
                    audit_remarks: fuelForm.audit_remarks || '',
                    audit_approved_km: fuelForm.audit_approved_km || '',
                    audit_mngr: fuelForm.audit_mngr || '',
                    account_mngr: fuelForm.account_mngr || '',
                    rpt_mgr_status: fuelForm.rpt_mgr_status || '',
                    manager_remarks: fuelForm.manager_remarks || '',
                    createdDTM: fuelForm.createdDTM || '',
                    account_status: fuelForm.account_status || '',
                    createdBy: fuelForm.createdBy || '',
                    manager_approved_date: fuelForm.manager_approved_date || '',
                    audit_approved_date: fuelForm.audit_approved_date || '',
                    account_approved_date: fuelForm.account_approved_date || '',
                    is_submitted: fuelForm.is_submitted || '',
                    total_km: fuelForm.total_km || '',
                    created_on: fuelForm.created_on || '',
                    trans_code: fuelForm.trans_code || '',
                });

                if (fuelRows && fuelImages.length > 0) {
                    setTransportRows(fuelImages);
                    console.log("Fuel Rows:", fuelImages);
                }

                if (fuelImages && fuelImages.length > 0) {
                    setImgRows(fuelImages);
                }

                if (fuelContentsImages && fuelContentsImages.length > 0) {
                    setFuelContentsImages(fuelContentsImages);
                }

            } else {
                setError(result.message || 'Failed to fetch form data');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            // setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRepairFormData();
    }, [id]);
    const calculateTotal = () => {
        // Calculate the total amount, make total of all total_fuel_amt rows
        const total_amt = transportRows.reduce((total, row) => total + (parseFloat(row.repair_amount) || 0), 0);
        return total_amt


    };




    useEffect(() => {
        calculateTotal();


    }, [transportRows]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isSubmitAllowed) {
            toast.error("Please fix the file size errors before submitting.");
            return;
        }
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const formattedFormData = { ...formData };

            // Convert image files to Base64
            console.log("Before processing images: ", formData.img);

            // Convert image files to Base64
            if (formattedFormData.img && Array.isArray(formattedFormData.img)) {
                const imgBase64Promises = formattedFormData.img.map(async (file) => {
                    if (file instanceof File) {
                        return await convertToBase64(file);
                    }
                    return file;
                });
                formattedFormData.img = await Promise.all(imgBase64Promises);
            }

            console.log("After processing images:", formattedFormData.img);


            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}updateRmRepairForm/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    formId: formData.id,  // Assuming `formData` contains form ID
                    rpt_mgr_status: formData.rpt_mgr_status,
                    manager_remarks: formData.manager_remarks,
                }),
            });

            const result = await response.json();
            if (result.status) {
                toast.success('Repair Form submitted successfully!');
                setTimeout(() => {
                    navigate('/edit_rm_repair_form/' + id);
                }, 2000);
                // window.location.reload();
            } else {
                toast.error(result.message || 'An error occurred while submitting the form.');
            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error('Failed to submit form');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Helper function to convert File to Base64
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const sendForApproval = async () => {
        if (!window.confirm("Are you sure you want to submit this form for approval? Once submitted, you cannot edit the form.")) {
            return; // Exit if user cancels
        }

        try {
            const response = await fetch(`${API_BASE_URL}submitRepairForm/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    formId: formData?.id, // Example form ID, replace with actual data
                    isSubmited: "YES"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            alert("Form submitted successfully for approval!");
            window.location.reload();
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("An error occurred while submitting the form.");
        }
    };





    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Edit Repair Form</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Repair Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <div className="box-body">
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData.emp_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee Band</label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_name">Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_acnum">Bank Ac.No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="bank_acnum"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="ifsc_code">IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Reporting Manager
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Location
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="location_name"
                                                                    id="name"
                                                                    value={formData.location_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-warning" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Details of Repair Form
                                                    </span>
                                                </center>

                                                <div className="transport-table-container mb-3 text-right">
                                                    <button type="button" onClick={handleAddTransportRow} className="btn btn-sm btn-primary">+</button>

                                                    {/* Responsive Table Wrapper */}
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <td colSpan="12"></td>
                                                                </tr>
                                                                <tr className="header-row text-center">
                                                                    <th>Repair Date<span className="text-danger">*</span></th>
                                                                    <th>Repair Time<span className="text-danger">*</span></th>
                                                                    <th>Driver Bmid<span className="text-danger">*</span></th>
                                                                    <th>Purpose<span className="text-danger">*</span></th>
                                                                    <th>Amount</th>
                                                                    <th>Remarks</th>
                                                                    <th>Meter Reading</th>
                                                                    <th>Attachment</th>

                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {transportRows.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                type="date"
                                                                                name="dated"
                                                                                value={row.repair_date}
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                max={new Date().toISOString().split("T")[0]}
                                                                                disabled
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                type="time"
                                                                                name="repair_time"
                                                                                value={row.repair_time}
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                disabled
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>

                                                                            <input placeholder='Number' list="vm" value={row.driver_bmid} className='form-control input-font' name='driver_bmid' id='driver_bmid'
                                                                                onChange={(e) => handleTransportChange(index, e)} disabled />

                                                                        </td>


                                                                        <td style={{ minWidth: '12rem' }}>

                                                                            <select
                                                                                className="form-control input-font"
                                                                                value={row.purpose}
                                                                                name="purpose"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                disabled
                                                                            >
                                                                                <option value="">Select Purpose</option>
                                                                                <option value="office_purpose">Office Purpose</option>
                                                                                <option value="branch_visit">Branch Visit</option>
                                                                                <option value="patient">Patient</option>
                                                                                <option value="other_purpose">Other Purpose</option>

                                                                            </select>

                                                                        </td>

                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                className="form-control input-font"
                                                                                type="number"
                                                                                value={Math.trunc(row.repair_amount)}
                                                                                disabled
                                                                                name="repair_amount"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '4rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                value={row.remarks}
                                                                                name="remarks"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                disabled
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '8rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={row.meter_reading}
                                                                                name="meter_reading"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                disabled
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '12rem' }}>
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <input
                                                                                    type="file"
                                                                                    name="meter_reading_image"
                                                                                    id="meter_reading_image"
                                                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                                                    onChange={(e) => handleTransportChange(index, e)}
                                                                                    className="form-control input-font"
                                                                                    disabled
                                                                                />
                                                                                {/* File Preview */}
                                                                                {row.meter_reading_image && typeof row.meter_reading_image === 'string' && (
                                                                                    <a
                                                                                        href={`${API_BASE_URL1}assets/uploads/${row.meter_reading_image}`}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="position-relative"
                                                                                    >
                                                                                        {row.meter_reading_image.toLowerCase().endsWith('.pdf') ? (
                                                                                            // Show PDF icon if the file is a PDF
                                                                                            <img
                                                                                                src={pdficon} // Replace with your PDF icon path
                                                                                                alt="meter_reading_image PDF"
                                                                                                style={{ width: '50px', height: '50px', borderRadius: '4px' }} // Add rounded corners
                                                                                            />
                                                                                        ) : (
                                                                                            // Show image if it's not a PDF
                                                                                            <img
                                                                                                src={`${API_BASE_URL1}assets/uploads/${row.meter_reading_image}`} // Actual image file path
                                                                                                alt="meter_reading_image"
                                                                                                style={{
                                                                                                    width: '50px',
                                                                                                    height: '50px',
                                                                                                    borderRadius: '4px',
                                                                                                    objectFit: 'cover',
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </a>
                                                                                )}
                                                                            </div>
                                                                        </td>

                                                                        <td>
                                                                            <button type="button" onClick={() => handleRemoveTransportRow(index)} className="btn btn-sm btn-danger">×</button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <td colSpan="4"></td>
                                                                    <td className="text-center font-weight-bold">
                                                                        Total Amt : ₹ {transportRows.reduce((total, row) => total + (parseFloat(row.repair_amount) || 0), 0)}
                                                                    </td>

                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-primary" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Additional Documents
                                                    </span>
                                                </center>
                                                <div className="document-table-container" style={{ marginBottom: '20px', textAlign: 'right' }}>
                                                    <table className="document-table" style={{ marginTop: '10px' }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ textAlign: 'center' }}>Click to Preview</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* Loop through fuelImages and display each document's image */}
                                                            {fuelContentsImages.length > 0 ? (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                            {fuelContentsImages.map((document) => {
                                                                                // Construct the image URL outside the JSX expression
                                                                                const imageUrl = `${API_BASE_URL1}assets/uploads/${document.img}`;

                                                                                return (
                                                                                    <div key={document.id} style={{ margin: '10px' }}>
                                                                                        <a href={imageUrl} target="_blank" rel="noopener noreferrer" className="position-relative">
                                                                                            {document.img && typeof document.img === 'string' && document.img.toLowerCase().endsWith('.pdf') ? (
                                                                                                // If the document is a PDF, show the PDF icon
                                                                                                <img
                                                                                                    src={pdficon} // Replace with the actual path to your PDF icon
                                                                                                    alt={`PDF Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '100px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            ) : document.img ? (
                                                                                                // Otherwise, show the image
                                                                                                <img
                                                                                                    src={imageUrl}
                                                                                                    alt={`Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '79px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                <span>No Image</span> // Fallback if document.img is missing
                                                                                            )}

                                                                                        </a>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        {error ? error : 'No documents available.'}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </fieldset>


                                            {/* Upload Images Section */}
                                            <section className="col-lg-12">
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                <label className="font-weight-bold">Upload Multiple Images:</label>
                                                <input
                                                    type="file"
                                                    name="img"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={handleFileChange}
                                                    className="form-control mb-3"
                                                    disabled
                                                />

                                                {/* Reporting Manager Section */}
                                                <div className="row mt-3">
                                                    {/* Reporting Manager Status */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="rpt_mgr_status" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Status <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="rpt_mgr_status"
                                                                id="rpt_mgr_status"
                                                                value={formData.rpt_mgr_status || ''}
                                                                onChange={handleChange}
                                                                className="form-control custom-select"
                                                                required

                                                            >
                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    {/* Reporting Manager Remarks */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="remarks" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Remarks <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <textarea
                                                                name="manager_remarks"
                                                                id="remarks"
                                                                value={formData.manager_remarks || ''}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                                required

                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        disabled={isSubmitting}
                                                        onClick={handleSubmit}
                                                    >
                                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                                    </button>
                                                    <button type="button" className="btn btn-secondary ml-3" onClick={handleBackClick}>
                                                        Cancel
                                                    </button>

                                                </div>
                                                <div className="col-sm-12 row" style={{ width: '100%' }}>
                                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                                        <b>Prepared by </b>
                                                        <p> {formData.emp_code} ({formData.comp_name})<br /> Date
                                                            : {formData.created_on}
                                                        </p>
                                                    </div>
                                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                                        {formData.rpt_mgr_status === 'Approved' && (
                                                            <>
                                                                <b> Approved by</b>
                                                                <p> {formData.report_mngr} ({RptMgrName})<br /> Date
                                                                    : {formData.manager_approved_date}
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                                        {formData.audit_status === 'Approved' && (
                                                            <>
                                                                <b> Verified by Audit Team</b>
                                                                <p>                         <span>
                                                                    {formData.audit_mngr} ({AdtMgrName})<br /> Date
                                                                    : {formData.audit_approved_date}
                                                                </span>
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </section>

                                        </form>

                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Edit_Repair_Form